import { useGetLecture } from '#api/lectures';
import { useEffect, useState } from 'react';
import { useDashboardCustomerMembershipState } from '../dahsboardCustomerMembershipState';

export const TotalPrice = () => {
  const {
    dashboardCustomerMembershipState,
    setDashboardCustomerMembershipState
  } = useDashboardCustomerMembershipState();

  const { data } = useGetLecture(dashboardCustomerMembershipState.lectureId);

  const price = data?.price;

  const { discount, totalRound, round } = dashboardCustomerMembershipState;

  const [calculationPrice, setCalculationPrice] = useState<number | null>(null);

  useEffect(() => {
    const lecturePrice = Number(price);

    if (totalRound > 0) {
      let totalPrice = (totalRound - (round || 0)) * lecturePrice;

      if (discount) {
        const numberDiscountValue = Number(discount.value);

        if (discount.unit === 'won') {
          totalPrice = totalPrice - numberDiscountValue;
        }

        if (discount.unit === 'percent') {
          totalPrice = totalPrice - totalPrice * (numberDiscountValue / 100);
        }
      }

      setCalculationPrice(totalPrice);
      setDashboardCustomerMembershipState(prev => ({
        ...prev,
        price: totalPrice
      }));
    }
  }, [totalRound, round, discount, price]);

  const getFormattedPrice = (price: number | null) => {
    if (!price) return 0;

    if (isNaN(price)) return 0;

    const roundedPrice = Math.round(price);

    return roundedPrice.toLocaleString();
  };

  return (
    <div className="w-full h-[89px] p-16 bg-[#1e1a24] rounded-lg border border-[#252230] flex-col justify-center items-center gap-8 inline-flex">
      <div className="text-[#938f9e] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
        총 결제 금액
      </div>
      <div className="justify-center items-center gap-4 inline-flex">
        <div className="text-[#7750e9] text-[22px] font-bold font-['Pretendard Variable'] leading-7 tracking-tight">
          {getFormattedPrice(calculationPrice)}
        </div>
        <div className="text-[#938f9e] text-base font-medium font-['Pretendard Variable'] leading-[21px]">
          원
        </div>
      </div>
    </div>
  );
};
